
<div
  style="padding-left:14%;padding-right:14%;padding-top: 3%;line-height: 25px;font-size: 19px"
>
  <div class="row">
    <img src="./assets/img/doktorslogo.png" style="height:60px" />
    <h3 style="float: right;margin-top: 20px" align="center">
      Refund Policy
    </h3>
  </div>
  <hr />

  <p style="margin-top: 60px"></p>

  <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>Returns</b>
  </div>

  <p>
    Our policy lasts 30 Days. If 30 days have gone by since your appointment,
    unfortunately we can’t offer you a refund your appointment amount.
  </p>
  <p>
    To be Eligible for a return, your appointment should be cancelled before 1
    day of appointment date or cancelled by the doctor with some valid reason
    which would be sent to you on mail or notification.
  </p>

  <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>Refunds (if applicable)</b>
  </div>
  <p>
    We will send you an email to notify you that we have received your returned
    amount. We will also notify you of the approval or rejection of your refund.
  </p>
  <p>
    If you are approved, then your refund will be processed, and a credit will
    automatically be applied to your credit card or original method of payment,
    within a certain amount of days.
  </p>

  <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>Late or missing refunds (if applicable)</b>
  </div>
  <p>
    If you haven’t received a refund yet, first check your bank account again.
    Then contact your credit card company, it may take some time before your
    refund is officially posted. Next contact your bank. There is often some
    processing time before a refund is posted. If you’ve done all of this and
    you still have not received your refund yet, please contact us at
    <a href="mailto:info@mavinglobus.com">info@mavinglobus.com</a>
  </p>
</div>
